const jobTasksUpdatedAtSelector = (jobID: string) => (
    state: sage.state.IRedux
): Date | undefined => {
    return state.jobs.jobTasksUpdatedAt[jobID];
};

export default jobTasksUpdatedAtSelector;
